import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import { default as locale } from 'date-fns/locale/pt-BR'
import { ApiWalletStatementBonus, WalletStatementBonus } from 'Types'

const parseExpiration = (data: ApiWalletStatementBonus): string => {
  const rawDate = parseISO(data.dateExpired)
  const expirationDate = subDays(rawDate, 1)

  return format(expirationDate, 'd MMM', { locale })
}

const parseRenew = (data: ApiWalletStatementBonus): string => {
  const renewDate = parseISO(data.dateExpired)

  return format(renewDate, 'd MMM', { locale })
}

const parseUnavailable = (data: ApiWalletStatementBonus): boolean => {
  const today = new Date()
  const rawDate = parseISO(data.dateExpired)
  const expiredDate = addDays(rawDate, 1)

  return today >= expiredDate && data.amount === 0
}

export const parseBonusBalance = (data: ApiWalletStatementBonus): WalletStatementBonus => {
  const hasDate = data.dateStarted !== null && data.dateExpired !== null

  return {
    current: data.amount,
    total: data.amountLastBonus,
    expirationDate: hasDate ? parseExpiration(data) : null,
    renewDate: hasDate ? parseRenew(data) : null,
    unavailable: hasDate ? parseUnavailable(data) : true,
  }
}

export default {
  parseBonusBalance
}
